import { AppIcon, type IconDefinition } from '@/components/ui/app-icon';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/** A small round icon button with its name as a tooltip. */
export function IconControl({
  label,
  icon,
  disabled,
  onClick,
}: {
  label: string;
  icon: IconDefinition;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type='button'
          aria-label={label}
          disabled={disabled}
          onClick={onClick}
          className={cn(
            'flex size-7 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors',
            'hover:bg-muted hover:text-foreground',
            'focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-hidden',
            'disabled:pointer-events-none disabled:opacity-40'
          )}
        >
          <AppIcon icon={icon} style={{ fontSize: 12 }} />
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
